import { Icon } from '@natera/material/lib/icon'
import { cn } from '~/shared/lib/cn'

interface PatientButtonProps {
  name?: string | null
  selected: boolean
  reviewed: boolean
  flagSeverity?: 'high' | 'low' | null
  onClick?: () => void
}

const getInitials = (name?: string | null) => {
  if (!name) return '…'
  const words = name.split(' ')
  if (words.length === 1) return words[0].charAt(0)
  return words[0].charAt(0) + words[1].charAt(0)
}

export function PatientButton({
  name,
  selected,
  reviewed,
  flagSeverity,
  onClick,
}: PatientButtonProps) {
  return (
    <div className="flex size-16 shrink-0 items-center justify-center">
      <div
        className={cn('relative rounded-lg p-2', {
          'bg-primary-focused': selected,
        })}
      >
        <button
          onClick={onClick}
          className={cn(
            'bg-surface-medium flex size-10 cursor-pointer items-center justify-center overflow-hidden rounded-full border-none p-0 text-sm leading-3.5 font-medium uppercase',
            {
              'bg-surface-lowest': selected,
            },
          )}
        >
          <span className="text-text-secondary">{getInitials(name)}</span>
        </button>
        {flagSeverity ? (
          <div className="absolute top-1.5 right-1.5">
            <Icon
              className={cn('text-[16px]', {
                'text-alert-warning-message': flagSeverity === 'high',
                'text-primary-main': flagSeverity === 'low',
              })}
              children="flag"
              fill
            />
          </div>
        ) : (
          reviewed && (
            <div className="absolute top-1.5 right-1.5">
              <Icon
                className="text-success-content text-[16px]"
                children="check_circle"
                fill
              />
            </div>
          )
        )}
      </div>
    </div>
  )
}
